import { useEffect, useRef, useState } from 'react';
import './AsmaSorry.css';

function Teddy() {
  return (
    <svg viewBox="0 0 300 290" className="sorry-teddy" role="img" aria-label="A little teddy holding a pink heart">
      <ellipse cx="150" cy="267" rx="94" ry="12" fill="#ead8ce" opacity=".5" />
      <g stroke="#795846" strokeWidth="3" strokeLinejoin="round">
        <ellipse cx="150" cy="206" rx="66" ry="63" fill="#dcb58e" />
        <circle cx="87" cy="68" r="30" fill="#dcb58e" /><circle cx="213" cy="68" r="30" fill="#dcb58e" />
        <circle cx="87" cy="68" r="17" fill="#f1d4bb" stroke="none" /><circle cx="213" cy="68" r="17" fill="#f1d4bb" stroke="none" />
        <ellipse cx="150" cy="117" rx="82" ry="72" fill="#e7c5a1" />
        <ellipse cx="150" cy="139" rx="31" ry="24" fill="#f8e7d2" stroke="none" />
        <path d="M110 116q7-9 14 0m52 0q7-9 14 0" fill="none" strokeLinecap="round" />
        <ellipse cx="150" cy="132" rx="8" ry="6" fill="#795846" stroke="none" />
        <path d="M150 138v6m-10 0q10 12 20 0" fill="none" strokeLinecap="round" />
        <ellipse cx="103" cy="134" rx="13" ry="7" fill="#eaa79e" stroke="none" /><ellipse cx="197" cy="134" rx="13" ry="7" fill="#eaa79e" stroke="none" />
        <ellipse cx="101" cy="247" rx="29" ry="23" fill="#e7c5a1" /><ellipse cx="199" cy="247" rx="29" ry="23" fill="#e7c5a1" />
        <path d="M150 239C65 191 111 158 150 188c39-30 85 3 0 51Z" fill="#e98c9e" stroke="#b96279" />
        <ellipse cx="93" cy="201" rx="20" ry="27" fill="#e7c5a1" transform="rotate(-30 93 201)" /><ellipse cx="207" cy="201" rx="20" ry="27" fill="#e7c5a1" transform="rotate(30 207 201)" />
      </g>
      <path d="m240 108 4-11 4 11 11 4-11 4-4 11-4-11-11-4Z" fill="#d3a34e" />
      <path d="M49 163c-19-13-8-23 0-14 8-9 19 1 0 14" fill="#dfa0ae" />
    </svg>
  );
}

export default function AsmaSorry() {
  const [opened, setOpened] = useState(false);
  const [response, setResponse] = useState('');
  const [hugs, setHugs] = useState(0);
  const [hugGlow, setHugGlow] = useState(false);
  const letterRef = useRef(null);
  const hugDialogRef = useRef(null);
  const hugButtonRef = useRef(null);
  const hugTimerRef = useRef(null);

  useEffect(() => () => window.clearTimeout(hugTimerRef.current), []);

  function sendHug() {
    window.clearTimeout(hugTimerRef.current);
    setHugs(count => count + 1);
    setResponse('hug');
    setHugGlow(true);
    hugTimerRef.current = window.setTimeout(() => {
      hugDialogRef.current?.showModal();
    }, 1400);
  }

  function takeTime() {
    window.clearTimeout(hugTimerRef.current);
    setHugGlow(false);
    setResponse('time');
  }

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Asma, a little sorry from my heart ♡';
    return () => { document.title = previousTitle; };
  }, []);

  useEffect(() => {
    if (opened) letterRef.current?.focus({ preventScroll: true });
  }, [opened]);

  return (
    <div className="asma-sorry">
      {hugGlow && (
        <div key={hugs} className="sorry-hug-magic" aria-hidden="true" onAnimationEnd={event => {
          if (event.target === event.currentTarget) setHugGlow(false);
        }}>
          {Array.from({ length: 20 }, (_, index) => (
            <span key={index} style={{ '--heart-left': `${5 + (index * 37) % 90}%`, '--heart-delay': `${(index % 5) * 0.14}s`, '--heart-drift': `${(index % 2 ? 1 : -1) * (25 + index * 4)}px`, '--heart-size': `${18 + (index % 4) * 10}px` }}>{index % 3 === 0 ? '✧' : '♡'}</span>
          ))}
        </div>
      )}
      <div className="sorry-grain" aria-hidden="true" />
      <header className="sorry-topbar">
        <a href="#sorry-home" className="sorry-wordmark"><span aria-hidden="true">♡</span> a little peace offering</a>
        <span className="sorry-topnote">especially for Asma <span aria-hidden="true">✿</span></span>
      </header>

      <section className="sorry-hero" id="sorry-home" aria-labelledby="sorry-title">
        <div className="sorry-doodle sorry-doodle-left" aria-hidden="true">✳<span>a tiny page,<br />a very big sorry.</span></div>
        <div className="sorry-doodle sorry-doodle-right" aria-hidden="true">♡<span>handle with care</span></div>
        <div className="sorry-tag">A SPECIAL DELIVERY FOR YOU</div>
        <h1 id="sorry-title">Asma, I'm <em>sorry.</em></h1>
        <p className="sorry-intro">Thoda sa sorry. Bahut saara dil.<br />Aur ek chhoti si koshish, tumhe phir se smile karane ki.</p>

        <div className="sorry-keepsake">
          <span className="sorry-tape" aria-hidden="true" />
          <span className="sorry-card-note">one bear-sized apology</span>
          <Teddy />
          <span className="sorry-bear-caption">this little guy is on team “I'm sorry” ♡</span>
          <span className="sorry-sticker" aria-hidden="true">100%<br />dil se</span>
        </div>

        <p className="sorry-handwritten">I made you a little something...</p>
        <a className="sorry-primary" href="#sorry-letter">A letter for you <span aria-hidden="true">↗</span></a>
        <span className="sorry-scroll-note">take your time, it's all yours</span>
      </section>

      <section className="sorry-letter-section" id="sorry-letter" aria-labelledby="sorry-letter-title">
        <span className="sorry-eyebrow">01 / STRAIGHT FROM THE HEART</span>
        <h2 id="sorry-letter-title">Some things deserve<br />more than a <em>“sorry.”</em></h2>
        <p>Isliye, yeh chhota sa letter. Sirf tumhare liye.</p>
        <button className={`sorry-envelope ${opened ? 'is-open' : ''}`} onClick={() => setOpened(!opened)} aria-expanded={opened} aria-controls="asma-letter">
          <span className="sorry-envelope-flap" aria-hidden="true" />
          <span className="sorry-envelope-address">To, Asma<br /><small>with a whole lot of heart</small></span>
          <span className="sorry-seal" aria-hidden="true">♡</span>
          <span className="sorry-envelope-hint">{opened ? 'fold the letter away ↑' : 'tap to open your letter ↗'}</span>
        </button>
        {opened && (
          <article className="sorry-letter" id="asma-letter" ref={letterRef} tabIndex={-1}>
            <span className="sorry-letter-date">a little note, with a lot of love</span>
            <h3>Dear Asma,</h3>
            <p>I'm sorry. Tumhe hurt karke mujhe achha nahi lag raha, aur main apni baat ko excuses ke peeche chhupana nahi chahta.</p>
            <p>Tumhari feelings matter karti hain. Main tumhari baat dhyaan se sunna chahta hoon, samajhna chahta hoon, aur apne actions se better karna chahta hoon.</p>
            <p className="sorry-respect">Asma, I really respect you, and I will always respect you.<br />Tumhari feelings, tumhari choices aur tumhari boundaries ki main hamesha respect karunga.</p>
            <p>Yeh cute sa page sab kuch magically theek nahi kar sakta. Bas ek chhoti si shuruaat hai, tumhe batane ki tum mere liye bahut special ho.</p>
            <p>Jab tum ready ho, hum baat kar sakte hain. Tab tak, take all the time you need. Aur agar isse tumhare face pe ek tiny si smile aayi... toh yeh little bear apna kaam kar gaya.</p>
            <p className="sorry-signoff">Dil se sorry,<br /><span>someone who cares about you ♡</span></p>
          </article>
        )}
      </section>

      <section className="sorry-promises" aria-labelledby="sorry-promises-title">
        <span className="sorry-eyebrow">02 / LITTLE PROMISES, BIG MEANING</span>
        <h2 id="sorry-promises-title">Less oops. <em>More effort.</em></h2>
        <div className="sorry-notes">
          <article className="sorry-note"><span aria-hidden="true">♡</span><h3>I'll listen better.</h3><p>Tumhari baat poori sununga.<br />Samajhne ke liye, sirf reply karne ke liye nahi.</p><small>pinky promise #01</small></article>
          <article className="sorry-note"><span aria-hidden="true">✿</span><h3>Little things matter.</h3><p>Tumhari feelings, tumhara time,<br />aur woh chhoti chhoti baatein. Sab important hain.</p><small>pinky promise #02</small></article>
          <article className="sorry-note"><span aria-hidden="true">☀</span><h3>I'll show up with care.</h3><p>Sirf cute words nahi.<br />Roz thodi understanding, thoda patience, aur effort.</p><small>pinky promise #03</small></article>
        </div>
      </section>

      <section className="sorry-hug-section" aria-labelledby="sorry-hug-title">
        <span className="sorry-eyebrow">03 / A LITTLE WARMTH, IF YOU WANT IT</span>
        <div className="sorry-hug-icon" aria-hidden="true">♡</div>
        <h2 id="sorry-hug-title">One tiny <em>virtual hug?</em></h2>
        <p>No rush. No pressure. Just a little warmth from me to you.</p>
        <div className="sorry-actions">
          <button ref={hugButtonRef} className="sorry-primary" onClick={sendHug} aria-haspopup="dialog">Send me a hug <span aria-hidden="true">♡</span></button>
          <button className="sorry-secondary" onClick={takeTime}>I need a little time</button>
        </div>
        <div className="sorry-response" role="status" aria-live="polite">
          {response === 'hug' && <div key={hugs} className="sorry-hug-result"><span aria-hidden="true">♡ ✧ ♡</span><strong>One warm, bear-sized hug. Just for you.</strong><span>Jab bhi chahiye, ek aur hug yahin milega.</span></div>}
          {response === 'time' && <div><strong>Of course, Asma. Take your time. ♡</strong><span>Jab tum ready ho, main sunne ke liye hoon.</span></div>}
        </div>
      </section>
      <dialog ref={hugDialogRef} className="sorry-hug-dialog" aria-labelledby="sorry-popup-title" aria-describedby="sorry-popup-message" onClose={() => hugButtonRef.current?.focus({ preventScroll: true })} onClick={event => {
        if (event.target === event.currentTarget) hugDialogRef.current.close();
      }}>
        <div className="sorry-popup-content">
          <button className="sorry-popup-close" aria-label="Close message" autoFocus onClick={() => hugDialogRef.current.close()}>×</button>
          <span className="sorry-popup-heart" aria-hidden="true">♡</span>
          <span className="sorry-eyebrow">ONE HUG, AND A LITTLE REQUEST</span>
          <h2 id="sorry-popup-title">I miss you, <em>Asma.</em></h2>
          <div id="sorry-popup-message">
            <p>Please mujhe phone aur WhatsApp se unblock kar do. 🥺😔</p>
            <p>I'm waiting to hear your voice. I missed you, aur tumhari awaaz bahut yaad aa rahi hai. 😢💔</p>
            <p className="sorry-popup-respect">I really respect you, and I will always respect you.</p>
            <p className="sorry-popup-gentle">Jab tum comfortable aur ready ho, tabhi. Tumhari space aur tumhare decision ki main respect karunga. ♡</p>
          </div>
          <a className="sorry-primary" href="tel:870009237">Please call me <span aria-hidden="true">♡</span></a>
        </div>
      </dialog>
      <footer className="sorry-footer"><span>made with care, a little courage & a whole lot of sorry</span><span>for Asma, always with kindness ♡</span></footer>
    </div>
  );
}
